import { render } from "./_Modal-info.vue?vue&type=template&id=871ebc74&scoped=true"
import script from "./_Modal-info.vue?vue&type=script&lang=js"
export * from "./_Modal-info.vue?vue&type=script&lang=js"

import "./_Modal-info.vue?vue&type=style&index=0&id=871ebc74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-871ebc74"

export default script